const AddressBlock = (props) => {
	const a = props.address;

	const l1 = a.address + ((a.address2 && a.address2.length) ? `, ${a.address2}` : '');
		  const l2 = `${a.city}, ${a.state} ${a.zip}`;

	return (

		<div>
			<h2>{ props.label }</h2>

			<div className="address-split">

				<div>
					
					<span className="address-field-header">Company</span>
					<b>{ a.company_name }</b>
						
					<span className="address-field-header">Customer</span>
					<b>{ `${a.first_name} ${a.last_name}` }</b>

					<span className="address-field-header">Address</span>
					<b>
						{ l1 }
						<br />
						{ l2 }
					</b>

				</div>

				<div>

					<span className="address-field-header">Phone</span>
					<b>{ a.phone }</b>

					<span className="address-field-header">Email</span>
					<b>{ a.email }</b>
						
				</div>

			</div>
		</div>
	);
};

export default AddressBlock;
